/**
 * Run async work over items with a hard concurrency cap.
 * Used for Owner Home balances and Waiting hub-question fan-out
 * (condition 7: bounded, no retry loops).
 */
export async function mapWithConcurrency<T, R>(
  items: readonly T[],
  limit: number,
  worker: (item: T, index: number) => Promise<R>,
): Promise<R[]> {
  const cap = Math.max(1, Math.floor(limit));
  const results = new Array<R>(items.length);
  let next = 0;

  const runners = Array.from({ length: Math.min(cap, items.length) }, async () => {
    while (next < items.length) {
      const index = next;
      next += 1;
      const item = items[index];
      if (item === undefined) return;
      results[index] = await worker(item, index);
    }
  });

  await Promise.all(runners);
  return results;
}
